webpackJsonp([107818501498521],{

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1022);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SitePage = function (_React$Component) {
	  _inherits(SitePage, _React$Component);
	
	  function SitePage() {
	    _classCallCheck(this, SitePage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SitePage.prototype.render = function render() {
	    var post = this.props.data.post;
	    return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } });
	  };
	
	  return SitePage;
	}(_react2.default.Component);
	
	exports.default = SitePage;
	module.exports = exports['default'];

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(51);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _forEach = __webpack_require__(130);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	__webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SitePost = function (_React$Component) {
	  _inherits(SitePost, _React$Component);
	
	  function SitePost() {
	    _classCallCheck(this, SitePost);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SitePost.prototype.more = function more(path) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'readmore', to: path },
	      _react2.default.createElement(
	        'span',
	        { className: 'btn btn-outline-primary btn-block' },
	        'MORE'
	      )
	    );
	  };
	
	  SitePost.prototype.isMore = function isMore(body) {
	    return body.match('<!--more-->');
	  };
	
	  SitePost.prototype.description = function description(body) {
	    var test = body.replace(/<blockquote>/g, '<blockquote class="blockquote">');
	    if (test.match('<!--more-->')) {
	      test = test.split('<!--more-->');
	      if (typeof test[0] !== 'undefined') {
	        return test[0];
	      }
	    }
	    return test;
	  };
	
	  SitePost.prototype.categories = function categories(data) {
	    var categories = [];
	    (0, _forEach2.default)(data, function (item, i) {
	      categories.push(_react2.default.createElement(
	        'span',
	        { className: 'badge badge-primary text-white', key: i },
	        item
	      ));
	    });
	    return categories;
	  };
	
	  SitePost.prototype.render = function render() {
	    var _props = this.props,
	        site = _props.site,
	        data = _props.data,
	        isIndex = _props.isIndex;
	
	    var title = (0, _get2.default)(data, 'frontmatter.title');
	    var path = (0, _get2.default)(data, 'frontmatter.path');
	    var date = (0, _get2.default)(data, 'frontmatter.date');
	    var html = (0, _get2.default)(data, 'html');
	    var description = (0, _get2.default)(data, 'frontmatter.description') || this.description(html);
	    var cate = (0, _get2.default)(data, 'frontmatter.category') || (0, _get2.default)(data, 'frontmatter.categories');
	    var isMore = isIndex && !!html.match('<!--more-->');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'articles col-md-12' },
	        _react2.default.createElement(
	          'div',
	          { className: 'article-wrap', key: path },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-header' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { style: { boxShadow: 'none' }, to: path },
	              _react2.default.createElement(
	                'h1',
	                null,
	                title
	              ),
	              _react2.default.createElement(
	                'time',
	                { dateTime: date },
	                date
	              )
	            ),
	            this.categories(cate)
	          ),
	          _react2.default.createElement('div', {
	            className: 'page-content',
	            dangerouslySetInnerHTML: { __html: isMore ? description : html }
	          }),
	          isMore ? this.more(path) : ''
	        )
	      )
	    );
	  };
	
	  return SitePost;
	}(_react2.default.Component);
	
	exports.default = SitePost;
	module.exports = exports['default'];

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(103);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SitePost = __webpack_require__(110);
	
	var _SitePost2 = _interopRequireDefault(_SitePost);
	
	var _SitePage = __webpack_require__(585);
	
	var _SitePage2 = _interopRequireDefault(_SitePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPostTemplate = function (_React$Component) {
	  _inherits(BlogPostTemplate, _React$Component);
	
	  function BlogPostTemplate() {
	    _classCallCheck(this, BlogPostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPostTemplate.prototype.render = function render() {
	    var post = (0, _get2.default)(this, 'props.data.post');
	    var site = (0, _get2.default)(this, 'props.data.site');
	    var layout = (0, _get2.default)(post, 'frontmatter.layout');
	    var title = (0, _get2.default)(post, 'frontmatter.title');
	    var siteTitle = (0, _get2.default)(site, 'meta.title');
	
	    var template = '';
	    if (layout !== 'page') {
	      template = _react2.default.createElement(_SitePost2.default, { data: post, site: site, isIndex: false });
	    } else {
	      template = _react2.default.createElement(_SitePage2.default, this.props);
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: title + ' | ' + siteTitle,
	        meta: [{ property: 'og:title', content: (0, _get2.default)(post, 'frontmatter.title') }, { property: 'og:type', content: 'article' }, {
	          property: 'og:description',
	          content: (0, _get2.default)(post, 'html').replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '').substr(0, 200)
	        }, {
	          property: 'og:url',
	          content: (0, _get2.default)(site, 'meta.url') + (0, _get2.default)(post, 'frontmatter.path')
	        }]
	      }),
	      template
	    );
	  };
	
	  return BlogPostTemplate;
	}(_react2.default.Component);
	
	exports.default = BlogPostTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-45ce515545f0ac17d916.js